import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "e-application-confirmation" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass('e-application-wrapper__card-footer e-application-wrapper__card-footer--no-border')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("text", null, _toDisplayString(_ctx.$t(`forms.confirmation.description`)), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        "event-name": "backHomeButton",
        "event-from": "/user/*/new-application",
        class: "defaultButton",
        label: _ctx.$t(`forms.confirmation.button_label`),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'MyApplications' })))
      }, null, 8, ["label"])
    ])
  ], 64))
}